export default "__VITE_ASSET__xTY3_ry___"